/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types'
import React from 'react'
import { Marker } from 'react-google-maps'

import Field from 'components/Field'
import Fieldset from 'components/Fieldset'
import FieldWithInput from 'components/FieldWithInput'
import Input from 'components/Input'
import InputAddress from 'components/InputAddress'
import Label from 'components/Label'
import Map from 'components/Map'

export default class FieldWithAddress extends React.Component {
  static propTypes = {
    addressComponents: PropTypes.object,
    label: PropTypes.string,
    //lat: PropTypes.number,
    //lon: PropTypes.number,
    onChange: PropTypes.func,
  }

  constructor(props) {
    super(props)

    const { addressComponents } = props

    //this.state = {
    //  country: (addressComponents && addressComponents.country) || '',
    //  lat: (addressComponents && addressComponents.lat) || 0,
    //  lng: (addressComponents && addressComponents.lon) || 0,
    //  state: (addressComponents && addressComponents.state) || '',
    //}

    this.state = this.updateFromAddressComponents(addressComponents)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.updateFromAddressComponents(nextProps.addressComponents))
  }

  updateFromAddressComponents = (addressComponents) => {
    addressComponents = addressComponents || {}

    return {
      country: addressComponents.country || '',
      //lat: addressComponents.lat || 0,
      lat: addressComponents.lat || '',
      //lng: addressComponents.lon || 0,
      lng: addressComponents.lon || '',
      state: addressComponents.state || '',
    }
  }

  handleChange = (address, lat, lng, state, country) => {
    this.setState({
      address,
      country,
      lat,
      lng,
      state,
    })

    const { onChange } = this.props

    if (onChange) onChange(address, lat, lng, state, country)
  }

  render() {
    const { label } = this.props
    const { address, country, lat, lng, state } = this.state

    // setInterval(() => {
    //   console.log('address', address)
    //   console.log('state', state)
    // }, 1000)

    return (
      <Fieldset title={label} className="FieldWithAddress">
        {/*label &&
          <Label>
            {label}
          </Label>
        */}
        {/*
        <Field>
          <Map
            containerElement={<div style={{ height: 300 }} />}
            loadingElement={<div style={{ height: 300 }} />}
            mapElement={<div style={{ height: 300 }} />}
            defaultCenter={{ lat: 0, lng: 0 }}
          />
        </Field>
        */}
        <FieldWithInput
          input={InputAddress}
          inputProps={{
            value: address,
            onSuccess: this.handleChange,
          }}
          label="Address"
        />
        <Field>
          <div className="uk-grid" uk-grid="true">
            <div className="uk-width-1-2">
              <FieldWithInput
                input={Input}
                inputProps={{
                  value: lat,
                }}
                label="Latitude"
                onValidChange={(e) => this.setState({ lat: e.target.value })}
              />
            </div>
            <div className="uk-width-1-2">
              <FieldWithInput
                input={Input}
                inputProps={{
                  value: lng,
                }}
                label="Longitude"
                onValidChange={(e) => this.setState({ lng: e.target.value })}
              />
            </div>
          </div>
        </Field>
        <Field>
          <div className="uk-grid" uk-grid="true">
            <div className="uk-width-1-2">
              <FieldWithInput
                input={Input}
                inputProps={{
                  value: state,
                }}
                label="State/Province"
                onValidChange={(e) => this.setState({ state: e.target.value })}
              />
            </div>
            <div className="uk-width-1-2">
              <FieldWithInput
                input={Input}
                inputProps={{
                  value: country,
                }}
                label="Country"
                onValidChange={(e) => this.setState({ country: e.target.value })}
              />
            </div>
          </div>
        </Field>
      </Fieldset>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FieldWithAddress/FieldWithAddress.js